import type LR from 'logrocket/dist/types';
import { getGlobalProperties } from '../global-properties/global-properties';

let M43LogRocket: typeof LR | undefined;

export async function setupLogrocket(): Promise<typeof M43LogRocket> {
    if (!M43LogRocket) {
        // DO NOT import LogRocket from 'logrocket'. 'logrocket/setup' has already loaded the logrocket packages, import from 'logrocket' will get `LogRocket has already been loaded, loading a second instance is not supported. This is often caused by loading LogRocket as a package in your application and as a script tag.` error
        // use getM43LogRocket() for M43 self-hosted logrocket instance
        // eslint-disable-next-line no-restricted-imports
        const { default: LogRocketSetup } = await import('logrocket/setup');
        const properties = await getGlobalProperties();
        const {
            LOGROCKET_PROJECT_SERVER: sdkServer,
            LOGROCKET_INGEST_SERVER: ingestServer,
            LOGROCKET_PROJECT_ID: projectId,
        } = properties;

        if (!sdkServer || !ingestServer || !projectId) {
            return;
        }

        const release = properties.VERSION;

        M43LogRocket = LogRocketSetup({
            sdkServer,
            ingestServer,
        });

        M43LogRocket.init(projectId, {
            release,
            console: {
                isEnabled: {
                    log: true,
                    info: true,
                },
                shouldAggregateConsoleErrors: true,
            },
        });
    }
    return M43LogRocket;
}

export const getM43LogRocket = () => M43LogRocket;
